import { SEARCH_TYPE } from './constants';

export const isMealDealPage = (searchType: string) => searchType === SEARCH_TYPE;
